<div class="message-container {{ variant }}">
  @if (title) {
    <h5 class="mb-3 w-100">{{ title }}</h5>
  }

  <div class="d-flex">
    @if (icon) {
      <i [class]="icon"></i>
    }

    <div class="message">
      @if (message) {
        <p class="m-0" [innerHTML]="message"></p>
      }
      <ng-content></ng-content>
    </div>
  </div>
</div>
